import React from 'react';

export default function StatCard({ label, value, accent }) {
  const colors = {
    red: 'border-red-700 bg-red-900/10 text-red-300',
    amber: 'border-amber-700 bg-amber-900/10 text-amber-300',
    green: 'border-green-700 bg-green-900/10 text-green-300',
  };
  return (
    <div className={`rounded-xl p-4 border ${colors[accent] || 'border-zinc-800 bg-zinc-900'}`}>
      <div className="text-xs text-zinc-400">{label}</div>
      <div className={`text-xl font-mono font-bold mt-1 ${accent ? '' : 'text-zinc-50'}`}>{value}</div>
    </div>
  );
}
